import { Injectable } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class UserPharmacyService {

  constructor(private readonly http: HttpClient,
    private readonly configurations: ConfigurationService) { }

  saveRequest(request) {
    return this.http.post(`${this.configurations.apiAddress}/api/UserPharmacyRequest/saveRequest`, request);
  }

  submitRequest(request) {
    return this.http.post(`${this.configurations.apiAddress}/api/UserPharmacyRequest/submitRequest`, request);
  }

  getCurrentUserRequest() {
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/getCurrentUserRequest`);
  }

  getRequetsForReview(searchText) {
    let myParams = new HttpParams()
      .set('searchText', searchText == undefined ? "" : searchText);
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/getRequestsForReview`, { params: myParams });
  }

  filterRequests(searchText, pageSize, pageNumber) {
    let myParams = new HttpParams()
      .set('searchText', searchText == undefined ? "" : searchText)
      .set("pageNumber", pageNumber.toString())
      .set("pageSize", pageSize.toString());
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/filterRequests`, { params: myParams });
  }

  getUserPharmacyRequestDetails(requestId) {
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/getUserPharmacyRequestDetails/${requestId}`);

  }

  getTargetAndLastPharmacyClasses(buId) {
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/getTargetAndLastPharmacyClasses/${buId}`);
  }

  approve(requestId) {
    return this.http.post(`${this.configurations.apiAddress}/api/UserPharmacyRequest/approve/${requestId}`, null);
  }

  reject(requestId) {
    return this.http.post(`${this.configurations.apiAddress}/api/UserPharmacyRequest/reject/${requestId}`, null);
  }

  deleteUserPharmacy(pharmacyId, buId) {
    let u = buId === undefined ? "" : Number(buId);
    return this.http.post(`${this.configurations.apiAddress}/api/UserPharmacyRequest/deleteUserPharmacy/${pharmacyId}?busId=` + u, null);

  }

  deleteUserPharmacyRequest(requestId) {
    return this.http.delete(`${this.configurations.apiAddress}/api/UserPharmacyRequest/deleteUserPharmacyRequest/${requestId}`);

  }

  getPendingDeletedPharmacy() {
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/getPendingDeletedPharmacy`);

  }
  approveDeleteUserPharmacy(busId, pharmacyId) {
    return this.http.post(`${this.configurations.apiAddress}/api/UserPharmacyRequest/approveDeleteUserPharmacy/${busId}/${pharmacyId}`, null);

  }
  rejectDeleteUserPharmacy(busId, pharmacyId) {
    return this.http.post(`${this.configurations.apiAddress}/api/UserPharmacyRequest/rejectDeleteUserPharmacy/${busId}/${pharmacyId}`, null);

  }
  approveAllDeleteUserPharmacy() {
    return this.http.post(`${this.configurations.apiAddress}/api/UserPharmacyRequest/approveAllDeleteUserPharmacy`, null);

  }
  rejectAllDeleteUserPharmacy() {
    return this.http.post(`${this.configurations.apiAddress}/api/UserPharmacyRequest/rejectAllDeleteUserPharmacy`, null);
  }

  getUserPharmacies(searchText?: string, userId?: number, busId?: number, getLastVisitNote: boolean = false) {
    let myParams = new HttpParams()
      .set("searchText", searchText === undefined ? "" : searchText)
      .set("busId", busId === undefined ? "" : busId.toString())
      .set("getLastVisitNote", getLastVisitNote.toString())
      .set("userId", userId === undefined ? "" : userId.toString());

    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/GetUserPharmacies`, { params: myParams });
  }

  alluserPharmacies(searchText?: string, userId?: number, pageSize?: number, pageNumber?: number) {
    let myParams = new HttpParams()
      .set("searchText", searchText === undefined ? "" : searchText)
      .set("pageSize", pageSize === undefined ? "900000" : pageSize.toString())
      .set("pageNumber", pageNumber === undefined ? "1" : pageNumber.toString())
      .set("userId", userId === undefined ? "" : userId.toString());
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/alluserPharmacies`, { params: myParams });
  }

  alluserPharmaciesTotalCount(searchText?: string, userId?: number) {
    let myParams = new HttpParams()
      .set("searchText", searchText === undefined ? "" : searchText)
      .set("userId", userId === undefined ? "" : userId.toString());
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/alluserPharmaciesTotalCount`, { params: myParams });
  }

  saveUserPharmacyHcos(request) {
    return this.http.post(`${this.configurations.apiAddress}/api/UserPharmacyRequest/saveUserPharmacyHcos`, request);
  }

  saveUserPharmacyStores(request) {
    return this.http.post(`${this.configurations.apiAddress}/api/UserPharmacyRequest/saveUserPharmacyStores`, request);
  }

  getUserPharmacyHcos(businessUnitId, hcoId, approvedOnly, isStore=false) {
    let myParams = new HttpParams()
      .set("businessUnitId", businessUnitId.toString())
      .set("approvedOnly", approvedOnly)
      .set("isStore", isStore.toString())
      .set("hcoId", hcoId.toString());
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/getUserPharmacyHcos`, { params: myParams });
  }

  getUserPharmacyHcoAddingRequests(isStore=false) {
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/getUserPharmacyHcoAddingRequests?isStore=${isStore}`);
  }

  approveOrRejectUserPharmacyHcoAddingRequest(userPharmacyHcoId, status) {
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/approveOrRejectUserPharmacyHcoAddingRequest/${userPharmacyHcoId}/${status}`);
  }

  approveAllOrRejectAllUserPharmacyHcoAddingRequests(status, isStore = false) {
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/approveAllOrRejectAllUserPharmacyHcoAddingRequests/${status}/${isStore}`);
  }


  getUserPharmacyHcoDeletingRequests(isStore = false) {
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/getUserPharmacyHcoDeletingRequests?isStore=${isStore}`);
  }

  approveOrRejectUserPharmacyHcoDeletingRequest(userPharmacyHcoId, status) {
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/approveOrRejectUserPharmacyHcoDeletingRequest/${userPharmacyHcoId}/${status}`);
  }

  approveAllOrRejectAllUserPharmacyHcoDeletingRequests(status, isStore = false) {
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/approveAllOrRejectAllUserPharmacyHcoDeletingRequests/${status}/${isStore}`);
  }

  deleteUserPharmacyHco(userPharmacyHcoId) {
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/deleteUserPharmacyHco/${userPharmacyHcoId}`);
  }

  getUserPharmacyHcoByHcoId(dateFrom, dateTo, hcoId?) {
    let myParams = new HttpParams()
      .set('dateFrom', dateFrom == undefined ? "" : dateFrom.toDateString())
      .set('dateTo', dateTo == undefined ? "" : dateTo.toDateString())
      .set('hcoId', hcoId == undefined ? "" : hcoId);
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/getHcpActivities`, { params: myParams })
  }

  getUserPharmacyHcoByHcpId(dateFrom, dateTo, hcpId?) {
    let myParams = new HttpParams()
      .set('dateFrom', dateFrom == undefined ? "" : dateFrom.toDateString())
      .set('dateTo', dateTo == undefined ? "" : dateTo.toDateString())
      .set('hcpId', hcpId == undefined ? "" : hcpId);
    return this.http.get(`${this.configurations.apiAddress}/api/UserPharmacyRequest/getUserPharmacyHcoByHcpId`, { params: myParams })
  }


}
